package pl.zar.tikthrow.util

import kotlinx.browser.window

actual fun openExternalUrl(url: String): Boolean {
    window.location.href = url
    return true
}
